import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_Persone_List_Interface, Persone_List_Interface } from 'src/app/Interface/Persone_List_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { PersonService } from 'src/app/Service/Person/Person.service';
import { RoleService } from 'src/app/Service/Role/Role.service';

@Component({
  selector: 'app-RoleUser',
  templateUrl: './RoleUser.component.html',
  styleUrls: ['./RoleUser.component.scss']
})
export class RoleUserComponent implements OnInit {

  @Input() inner_Role: General_Interface = Empty_General_Interface()
  @Output() outter_Role = new EventEmitter<number>();

  Token: String = ""
  Filter_title: string = ""
  page: number = 0;
  Procssing: boolean = false

  modalRef_Delete: any;

  constructor(
    private Role_Service: RoleService,
    private Alertify_Service: AlertifyService,
    private modalService: BsModalService,
    private Person_Service: PersonService,
  ) { }


  DataList_RoleUser: Array<Persone_List_Interface> = []
  Data_Seleted_Delete: Persone_List_Interface = Empty_Persone_List_Interface()

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.ReadData_RoleUser()


  }

  ReadData_RoleUser() {
    this.Procssing = true
    this.Role_Service.GetPerson(this.Token, this.inner_Role.id).subscribe(
      data => {
        this.DataList_RoleUser = data
        this.Procssing = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  Change_Filter_title() {
    this.page = 0
  }

  Delete(item: Persone_List_Interface) {
    item.DeletingProccess = true
    this.modalRef_Delete.hide()
    this.Role_Service.DeletePerson(this.Token, item.id).subscribe(
      data => {
        if (item.del == false)
          this.Alertify_Service.SuccessMessage("Deactivated successfully.")
        else
          this.Alertify_Service.SuccessMessage("Activated successfully.")
        this.ReadData_RoleUser()
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  openModal(template: TemplateRef<any>, Record) {
    this.Data_Seleted_Delete = Record
    this.modalRef_Delete = this.modalService.show(template);
  }


  onBack() {
    this.outter_Role.emit(-1);
  }



  //#region  Person
  modalRef_Person: any;
  modalRef_Person_Delete: any;
  Procssing_Person: boolean = false
  Selected_Chart_Person: Persone_List_Interface = Empty_Persone_List_Interface()

  Personpage: number = 0;
  Filter_Familly: string = ''
  Filter_Area: string = ''

  Change_Filter() {
    this.Personpage = 0
  }

  ReadData_Person() {
    this.Procssing_Person = true

    this.Person_Service.GetActive(this.Token).subscribe(
      data => {
        this.DataList_Person = data
        this.Procssing_Person = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  DataList_Person: Array<Persone_List_Interface> = []

  Set_Selected_Person_Record(item: Persone_List_Interface) {

    this.modalRef_Person.hide()
    this.Role_Service.AddPerson(this.inner_Role.id, item.id, this.Token).subscribe(
      data => {
        if (data['id'] == -1)
          this.Alertify_Service.ErrorMessage(item.fullname  + " already exists.")
        else {
          this.Alertify_Service.SuccessMessage(item.fullname + " was added.")
          this.ReadData_RoleUser()
        }
      }
    )
  }

  openModal_Person(template: TemplateRef<any>) {

    this.modalRef_Person = this.modalService.show(template);
  }

  //#endregion



}
